export enum UserPermission {
  CreatePartner = 'create-partner',
  ReadPartner = 'read-partner',
  UpdatePartner = 'update-partner',
  DeletePartner = 'delete-partner',
  CreatePartnerHistory = 'create-partner-history',
  UpdatePartnerHistory = 'update-partner-history',
  DeletePartnerHistory = 'delete-partner-history',
}
